import { Component } from 'react';
import PropTypes from 'prop-types';

import { getStyleValue } from '../Helpers/Helpers';

import './Details.css';

import { Divider } from '@mui/material';

class Details extends Component {
	render() {
		return (
			<div className={this.props.fullWidth ? 'details details-full-width' : 'details'}>
				<h2 className={this.props.primary ? 'details-primary' : null}>{this.props.header}</h2>
				{this.props.children}
			</div>
		);
	}
}

Details.propTypes = {
	header: PropTypes.string,
	fullWidth: PropTypes.bool,
};

class DetailsItem extends Component {
	render() {
		let className = '';
		if (this.props.label) {
			className = 'details-item';
		} else {
			className = 'details-item details-item--nolabel';
		}
		if (this.props.error) {
			className += ' details-item--error';
		}
		if (this.props.noMargin) {
			className += ' details-item--no-margin';
		}
		return (
			<div className={className}>
				{ this.props.label &&
				<p className='details-item-label'>
					{this.props.label}&nbsp;{this.props.required ? '*' : ''}
				</p>
				}
				<div>{this.props.children}</div>
			</div>
		);
	}
}

DetailsItem.propTypes = {
	primary: PropTypes.bool,
	label: PropTypes.string,
};

class DetailsDivider extends Component {
	render() {
		return <Divider style={{ marginLeft: `-${getStyleValue('spacing-half')}`, marginBottom: getStyleValue('spacing-default')}} />;
	}
}

export { Details as default, DetailsItem, DetailsDivider };
